module.exports = __webpack_public_path__ + "media/images/emblems/Spiringen-Wappen-f26ebd178cfe4e83063f806288251574.svg";